import React from 'react';
import { X, Download, ExternalLink } from 'lucide-react';
import { Button } from './ui/button';

// Use relative API path for same-origin requests (works in all environments)
const API = '/api';

export const PDFViewer = ({ pdf, onClose }) => {
  if (!pdf) return null;

  const pdfUrl = `${API}/amazing-reads/view/${pdf.id}`;

  return (
    <div className="fixed inset-0 z-[100] bg-black flex flex-col">
      {/* Header */}
      <div className="bg-[#0F1A2A] border-b border-white/10 px-4 sm:px-6 py-3 flex-shrink-0">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex-1 min-w-0 mr-4">
            <h2 className="text-base sm:text-lg font-bold text-white truncate">{pdf.title}</h2>
            {pdf.author && (
              <p className="text-xs sm:text-sm text-gray-400">By {pdf.author}</p>
            )}
          </div>
          
          <div className="flex items-center gap-2">
            {/* Open in New Tab */}
            <a
              href={pdfUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button
                variant="outline"
                size="sm"
                className="bg-white/5 border-white/10 text-white hover:bg-white/10 gap-1 text-xs"
              >
                <ExternalLink className="h-3 w-3 sm:h-4 sm:w-4" />
                <span className="hidden sm:inline">New Tab</span>
              </Button>
            </a>

            {/* Download Button */}
            <a
              href={pdfUrl}
              download={pdf.original_filename}
            >
              <Button
                variant="outline"
                size="sm"
                className="bg-white/5 border-white/10 text-white hover:bg-white/10 gap-1 text-xs"
              >
                <Download className="h-3 w-3 sm:h-4 sm:w-4" />
                <span className="hidden sm:inline">Download</span>
              </Button>
            </a>

            {/* Close Button */}
            <Button
              variant="outline"
              size="sm"
              onClick={onClose}
              className="bg-white/5 border-white/10 text-white hover:bg-white/10 text-xs px-3"
            >
              <X className="h-3 w-3 sm:h-4 sm:w-4" />
              <span className="hidden sm:inline ml-1">Close</span>
            </Button>
          </div>
        </div>
      </div>

      {/* PDF Viewer - Simple iframe approach */}
      <div className="flex-1 overflow-hidden bg-gray-900 relative">
        <iframe
          src={pdfUrl}
          className="w-full h-full border-0 absolute inset-0"
          title={pdf.title}
          style={{ backgroundColor: '#1a1a1a' }}
        />
      </div>

      {/* Footer Instructions */}
      <div className="bg-[#0F1A2A] border-t border-white/10 px-4 py-2 flex-shrink-0">
        <p className="text-xs text-gray-400 text-center">
          Use browser's built-in PDF controls to zoom and navigate • 
          {' '}<span className="hidden sm:inline">If PDF doesn't load, try "New Tab" or "Download" buttons</span>
          <span className="sm:hidden">Tap "New Tab" if PDF doesn't load</span>
        </p>
      </div>
    </div>
  );
};
